import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: 'E potrivit și pentru mine dacă “funcționez” dar sunt pe interior praf?',
    answer: 'Da. Mulți oameni arată bine pe exterior, dar sunt copleșiți în interior. În Metoda 3S lucrăm exact diferența dintre “a supraviețui” și “a trăi cu pace și claritate”.'
  }, {
    question: 'Dacă am încercat terapie și n-a mers?',
    answer: 'În sesiunea de evaluare vedem ce a lipsit: potrivirea, structura, practica dintre sesiuni, profunzimea sau direcția. Apoi alegem varianta corectă pentru tine: 1:1, atelier sau curs.'
  }, {
    question: 'Lucrezi și cu bărbați și cu femei?',
    answer: 'Da. Procesul este adaptat la felul în care fiecare gestionează frica, controlul, relațiile și deciziile.'
  }];
  return <Section id="faq" background="white" data-id="element-49">
      <div className="max-w-3xl mx-auto" data-id="element-50">
        <div className="text-center mb-12" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-52">
            Întrebări frecvente
          </h2>
        </div>

        <div className="space-y-4" data-id="element-53">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-54" />)}
        </div>
      </div>
    </Section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden transition-all duration-300 hover:border-brand-primary/30" data-id="element-55">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-brand-bg transition-colors" data-id="element-56">
        <span className="font-medium text-lg text-brand-text pr-8" data-id="element-57">
          {question}
        </span>
        {isOpen ? <Minus className="w-5 h-5 text-brand-primary flex-shrink-0" data-id="element-58" /> : <Plus className="w-5 h-5 text-brand-primary flex-shrink-0" data-id="element-59" />}
      </button>

      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-60">
        <div className="p-6 pt-0 bg-white text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-61">
          {answer}
        </div>
      </div>
    </div>;
}